class QueryString {
  getQueryStringFromObj(obj) {
    var str = "";
    for (var key in obj) {
      if (obj[key]) {
        if (str !== "") {
          str += "&";
        }
        str += key + "=" + obj[key];
      }
    }
    return str;
  }
}
export default new QueryString();
